import { defineStore } from "pinia";
import { residents } from "@/stores/resident";

const baseUsers = [
  {
    id: 1,
    username: "admin",
    password: "1234",
    name: "ผู้ดูแลระบบ",
    role: "admin",
    email: "admin@centralfee.local",
  },
  {
    id: 2,
    username: "finance",
    password: "1234",
    name: "เจ้าหน้าที่การเงิน",
    role: "finance",
    email: "finance@centralfee.local",
  },
];

const residentUsers = residents.map((resident) => ({
  id: resident.id + 100,
  username: resident.residentCode.toLowerCase(), // เช่น res-001
  password: "1234",
  name: resident.name,
  role: "user",
  email:
    resident.email || `${resident.residentCode.toLowerCase()}@centralfee.local`,
  residentId: resident.id,
  residentCode: resident.residentCode,
  unitCode: resident.unitCode,
}));

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: JSON.parse(localStorage.getItem("cm_user")) || null,
    token: localStorage.getItem("cm_token") || null,
    loading: false,
    error: "",
    users: [...baseUsers, ...residentUsers],
  }),

  getters: {
    isAuthenticated: (state) => !!state.token,
  },

  actions: {
    syncResidentUsers(residents) {
      const baseUsers = this.users.filter(
        (user) => user.role === "admin" || user.role === "finance",
      );

      const residentUsers = residents.map((resident) => ({
        id: resident.id + 100,
        username: resident.residentCode.toLowerCase(), // เช่น res-001
        password: "1234",
        name: resident.name,
        role: "user",
        email:
          resident.email ||
          `${resident.residentCode.toLowerCase()}@centralfee.local`,
        residentId: resident.id,
        residentCode: resident.residentCode,
        unitCode: resident.unitCode,
      }));

      this.users = [...baseUsers, ...residentUsers];
    },
    async login(payload) {
      this.loading = true;
      this.error = "";

      await new Promise((resolve) => setTimeout(resolve, 700));

      const foundUser = this.users.find(
        (user) =>
          user.username === payload.username &&
          user.password === payload.password,
      );

      if (!foundUser) {
        this.loading = false;
        this.error = "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง";
        return { success: false };
      }

      const fakeToken = `mock-token-${Date.now()}`;

      this.user = {
        id: foundUser.id,
        username: foundUser.username,
        name: foundUser.name,
        role: foundUser.role,
        email: foundUser.email,
        residentId: foundUser.residentId || null,
        residentCode: foundUser.residentCode || null,
        unitCode: foundUser.unitCode || null,
      };

      this.token = fakeToken;

      localStorage.setItem("cm_user", JSON.stringify(this.user));
      localStorage.setItem("cm_token", fakeToken);

      this.loading = false;
      return { success: true };
    },

    logout() {
      this.user = null;
      this.token = null;
      this.error = "";

      localStorage.removeItem("cm_user");
      localStorage.removeItem("cm_token");
    },
  },
});
